// Secondary cache for heavy schedule objects (with patterns)
// Redux state holds schedule metadata, cache holds full objects with patterns

const MAX_CACHE_AGE = 1000 * 60 * 1000; // 1000 minutes ~17hr

const cache = new Map(); // id -> heavy schedule object
let lastRefreshTimestamp = null;

// Check if cache is stale and needs refresh
export function isCacheStale() {
  if (!lastRefreshTimestamp) return true; // No timestamp = needs refresh
  
  const timeSinceRefresh = Date.now() - lastRefreshTimestamp;
  return timeSinceRefresh > MAX_CACHE_AGE; // More than 1000 minutes
}

// Get time since last refresh in minutes
export function getMinutesSinceRefresh() {
  if (!lastRefreshTimestamp) return null;
  return Math.floor((Date.now() - lastRefreshTimestamp) / (1000 * 60));
}

export function putSchedule(s) {
    cache.set(s.id, s);
}

export function removeSchedule(id) {
  cache.delete(id);
}

export function putManySchedules(arr) {
  cache.clear(); // Clear all old entries first
  for (const s of arr) {
    cache.set(s.id, s);
  }
  lastRefreshTimestamp = Date.now(); // Update refresh timestamp
}


export function getSchedule(id) {
  return cache.get(id) || null;
}

export function hasSchedule(id) {
  return cache.has(id);
}

export function clearSchedules() {
  cache.clear();
  lastRefreshTimestamp = null;
}

/**
 * Invalidate cache without clearing (forces next check to refetch)
 * Call this after mutations that might affect multiple schedules
 */
export function invalidateCache() {
  lastRefreshTimestamp = null; // Set to null to force refresh on next check
}


// export function getSchedulesByDeviceId(deviceId) {
//   const result = [];
//   const numDeviceId = Number(deviceId);

//   for (const schedule of cache.values()) {
//     if (schedule.device_ids && schedule.device_ids.includes(numDeviceId)) {
//       result.push(schedule);
//     }
//   } return result;
// }


// Get schedule metadata (without patterns) by id
export function getScheduleMeta(id, opts = { clone: true }) {
  const s = cache.get(id);
  if (!s) return null;

  const { patterns, ...meta } = s;
  if (!opts.clone) return meta;

  if (typeof structuredClone === 'function') {
    return structuredClone(meta);
  }
  return JSON.parse(JSON.stringify(meta));
}

/**
 * Get cache stats for debugging
 */
export function getCacheStats() {
  return {
    size: cache.size,
    lastRefreshTimestamp,
    minutesSinceRefresh: getMinutesSinceRefresh(),
    isStale: isCacheStale(),
  };
}